module.exports = __webpack_public_path__ + "img/notes_and_little_circles.3ed6407.svg";